import { render } from "./tradeCoinFutures.vue?vue&type=template&id=4b196d39"
import script from "./tradeCoinFutures.vue?vue&type=script&lang=js"
export * from "./tradeCoinFutures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__